import HeaderBar from "../../../Components/UI/headerbar";
import CouponsTab from "../components/CouponsTab";

const CouponsPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar title="التسويق" content="إدارة الكوبونات والعروض والبانرات." />

      <div className="mt-4">
        <CouponsTab />
        </div>
    </div>
  );
};

export default CouponsPage;
